import { Button, Grid } from "@mui/material";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const SuperAdminTabs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { label: "Dashboard", path: "/dashboardsuperadmin" },
    { label: "Financial Dashboard", path: "/financialdashboard" },
    { label: "Client/Org", path: "/createorganizationsview" },
    { label: "Trails", path: "/dashboardtrails" },
    { label: "Subscriptions", path: "/subscriptions" },
    { label: "Package", path: "/createpackage" },
  ];

  return (
    <Grid
      container
      spacing={1}
      sx={{
        background: "#F5F8FF",
        margin: { xs: "30px 0px 0px 0px", sm: "0px", md: "10px" },
        width: "100%",
        borderRadius: "5px",
        padding: { xs: "0px", sm: "0px", md: "10px" },
        fontWeight: 600,
        display: "flex",
        flexWrap: "nowrap",
      }}
    >
      {tabs.map((tab) => (
        <Grid item key={tab.path}>
          <Button
            variant="contained"
            size="medium"
            sx={{
              width: "100%",
              margin: "5px",
              fontWeight: "inherit",
              background:
                location.pathname === tab.path ? "#33499F" : "#D2F0F4",
              color: location.pathname === tab.path ? "#fff" : "#000000",
              "&:focus": { outline: "none" },
              "&:hover": { color: "white", background: "#33499F" },
            }}
            onClick={() => navigate(tab.path)}
          >
            {tab.label}
          </Button>
        </Grid>
      ))}
    </Grid>
  );
};

export default SuperAdminTabs;
